import { render } from "./LandingInfoPage.vue?vue&type=template&id=2f1814db&scoped=true"
import script from "./LandingInfoPage.vue?vue&type=script&lang=js"
export * from "./LandingInfoPage.vue?vue&type=script&lang=js"

import "./LandingInfoPage.vue?vue&type=style&index=0&id=2f1814db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1814db"]])

export default __exports__